import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { IMetadata } from "../../interface/metadata";
import metaContent from "../../cms/meta.json";
import {
  sanitizeUrl,
  buildCanonicalUrl,
  sanitizePathname,
} from "../../utils/sanitizeUrl";

export interface IHeadProps {
  metadata?: IMetadata;
}

const headElementSelectors = [
  "meta[name='description']",
  "link[rel='canonical']",
  "meta[property='og:title']",
  "meta[property='og:url']",
  "meta[property='og:description']",
  "title",
];

const helmetify = (selector: string) =>
  document.querySelector(selector)?.setAttribute("data-react-helmet", "true");

export const Head = ({ metadata }: IHeadProps) => {
  useEffect(() => {
    headElementSelectors.forEach(helmetify);
  }, []);

  const metaTitle = metadata?.title
    ? `${metadata?.title}${metaContent.titleSuffix}`
    : metaContent.defaultTitle;
  const metaDescription =
    metadata?.description || metaContent.defaultDescription;
  const canonicalUrl = metadata?.canonicalUrl
    ? sanitizeUrl(metadata.canonicalUrl)
    : buildCanonicalUrl(
        metaContent.canonicalBaseUrl,
        sanitizePathname(window.location.pathname)
      );

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};
